import { z } from 'zod';
import { DateOnlySchema, IdSchema, PageInfoSchema, TimestampSchema } from './common.js';
export const ProjectStatusSchema = z.enum([
    'planned',
    'active',
    'on_hold',
    'completed',
    'cancelled',
]);
export const ProjectSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    companyId: IdSchema.nullable(),
    name: z.string(),
    code: z.string().nullable(),
    status: ProjectStatusSchema,
    description: z.string().nullable(),
    startDate: DateOnlySchema.nullable(),
    endDate: DateOnlySchema.nullable(),
    ownerMembershipId: IdSchema.nullable(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const CreateProjectRequestSchema = z.strictObject({
    companyId: IdSchema.nullable().default(null),
    name: z.string().trim().min(1).max(200),
    code: z.string().trim().max(50).nullable().default(null),
    status: ProjectStatusSchema.default('planned'),
    description: z.string().trim().max(10_000).nullable().default(null),
    startDate: DateOnlySchema.nullable().default(null),
    endDate: DateOnlySchema.nullable().default(null),
    ownerMembershipId: IdSchema.nullable().default(null),
});
export const UpdateProjectRequestSchema = CreateProjectRequestSchema.partial();
export const ProjectListSchema = z.strictObject({
    items: z.array(ProjectSchema),
    page: PageInfoSchema,
});
